import { Component } from '@angular/core';
import { Web3WalletService } from '../../../services/web3-wallet.service';
import { TranslateModule } from '@ngx-translate/core';

var window: Window & {
  ethereum: any
  web3: any
  trustwallet: any
} = globalThis as any;

@Component({
  imports: [
    TranslateModule
  ],
  selector: 'connect-wallet-page',
  templateUrl: './connect-wallet.page.html',
  styleUrl: './connect-wallet.page.scss'
})
export class ConnectWalletPage {

  constructor(private readonly web3WalletService: Web3WalletService) {

  }

  async onConnectMetaMask() {
    const connectionRef = await this.web3WalletService.connect('metamask');
    await this.web3WalletService.useSigner(connectionRef);
  }

  async onConnectCoinbase() {
    const connectionRef = await this.web3WalletService.connect('coinbase');
    await this.web3WalletService.useSigner(connectionRef);
  }

  async onConnectWalletConnect() {
    const connectionRef = await this.web3WalletService.connect('walletconnect');
    await this.web3WalletService.useSigner(connectionRef);
  }

  async onConnectSequence() {
    // const connectionRef = await this.web3WalletService.connect('sequence');
    // await this.web3WalletService.useSigner(connectionRef);
  }

  
}